import React, { FC } from 'react'
import {
  Affilates,
  Contact,
  CTA,
  Guests,
  HeroWrapper,
  Shows,
  Benefits,
} from '../components/Home'
import { Reveal } from '../components/shared'

const Home: FC = () => {
  return (
    <>
      {/* HeroWrapper is the hero band, the sponsor logo strip directly beneath
          it, and the opening services section. */}
      <HeroWrapper />
      <Reveal>
        <Benefits />
      </Reveal>
      <Reveal>
        <Guests />
      </Reveal>
      <Reveal>
        <Shows />
      </Reveal>
      <Reveal>
        <Affilates />
      </Reveal>
      <Reveal>
        <CTA />
      </Reveal>
      <Reveal>
        <Contact />
      </Reveal>
    </>
  )
}
export default Home
